import {
  LOGIN_ACCOUNT,
  LOGIN_ASYNC_ACCOUNT,
  ERROR_LOGIN,
  CLOSE_SESSION,
  CHANGE_PASSWORD,
} from './../Action-type/Index';

const initialState = {
  user: {
    id: 0,
  },
  login: null,
}

function sessionReducer(state = initialState, action) {
  // console.log('action', action)
  switch (action.type) {
    case LOGIN_ACCOUNT: return {
      user: { ...action.payload.session.user },
      token: action.payload.session.token,
      login: 'ok'
    };
    case LOGIN_ASYNC_ACCOUNT: return { ...state };
    case ERROR_LOGIN: return {
      ...initialState,
      login: 'fail'
    };
    case CLOSE_SESSION: return { ...initialState };
    case CHANGE_PASSWORD: return { ...state };
    default: return { ...state };
  }
}

export default sessionReducer;